import { Link } from 'react-router-dom';
import { topics } from '@/mocks/topics';

const topicLink: Record<string, string> = {
  'topic-plot': '/detail/yu-nv-xin-jing-2',
  'topic-character': '/detail/yu-nv-xin-jing-2',
  'topic-world': '/category?genre=%E6%AD%A6%E4%BE%A0',
  'topic-aesthetic': '/category',
};

export default function TopicsSection() {
  return (
    <section className="w-full bg-background-50 px-4 md:px-8 py-12 md:py-16">
      <div className="max-w-2xl">
        <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">影视专题推荐</h2>
        <p className="mt-2 text-sm text-foreground-600">
          不只是剧情简介——从时间线梳理到角色深挖，用专题的方式带你读懂作品。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2">
        {topics.map((topic) => (
          <Link
            key={topic.id}
            to={topicLink[topic.id] ?? '/category'}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-100 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300 cursor-pointer sm:flex-row"
          >
            <div className="relative h-44 w-full shrink-0 overflow-hidden bg-background-200 sm:h-auto sm:w-52">
              <img
                src={topic.cover}
                alt={`${topic.title} 专题配图`}
                title={topic.title}
                className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="flex flex-1 flex-col p-5">
              <span className="inline-flex w-fit items-center rounded-full bg-accent-100 px-2.5 py-1 font-label text-[11px] text-accent-800">
                {topic.tag}
              </span>
              <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                {topic.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-7 text-foreground-600 line-clamp-3">{topic.desc}</p>
              <div className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                <span className="flex items-center gap-1"><i className="ri-article-line"></i> {topic.count} 篇内容</span>
                <span className="flex items-center gap-1 text-primary-700">进入专题 <i className="ri-arrow-right-line"></i></span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}